var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplyNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92121 11.9001L1.35321 8.62006C1.24562 8.55648 1.15645 8.46595 1.09452 8.3574C1.03258 8.24886 1 8.12604 1 8.00106C1 7.87609 1.03258 7.75327 1.09452 7.64472C1.15645 7.53617 1.24562 7.44564 1.35321 7.38206L5.92121 4.10006C6.0301 4.03601 6.154 4.00192 6.28033 4.00123C6.40666 4.00055 6.53092 4.0333 6.6405 4.09616C6.75008 4.15903 6.84108 4.24976 6.90426 4.35916C6.96743 4.46856 7.00054 4.59273 7.00021 4.71906V6.00006C8.50021 6.00006 13.0002 6.00006 14.0002 14.0001C11.5002 9.50006 7.00021 10.0001 7.00021 10.0001V11.2811C7.00021 11.8411 6.39421 12.1791 5.92121 11.9011V11.9001Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyNormal);
export default __webpack_public_path__ + "static/media/reply-normal.1f252cf5b1c7bd478105ef7c54e938ac.svg";
export { ForwardRef as ReactComponent };